import { render } from "./menuStartCategoryTitle.vue?vue&type=template&id=2d3fd4ce&scoped=true"
import script from "./menuStartCategoryTitle.vue?vue&type=script&lang=js"
export * from "./menuStartCategoryTitle.vue?vue&type=script&lang=js"

import "./menuStartCategoryTitle.vue?vue&type=style&index=0&id=2d3fd4ce&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2d3fd4ce"

export default script